const BASE_TITLE = 'Atlas';

export const getBrowserTitle = (environmentName: string): string => {
  if (environmentName === 'local') {
    return `${BASE_TITLE} (Local)`;
  }

  if (environmentName === 'dev') {
    return `${BASE_TITLE} DEV`;
  }

  if (environmentName === 'uat') {
    return `${BASE_TITLE} UAT`;
  }

  return BASE_TITLE;
};
